// extracted by mini-css-extract-plugin
export default {"cardContent":"ResumenMetricas_cardContent__ifjT8","icon":"ResumenMetricas_icon__Tph4W","resumen-general":"ResumenMetricas_resumen-general__9rWCQ"};